/* eslint no-undef: "error" */

import React, { useState, useEffect } from "react";
import { object, array, string, number } from "prop-types";
import assetify from "@quintype/framework/assetify";
import get from "lodash/get";
import { connect } from "react-redux";

import StoryContent from "../../molecules/StoryContent";
import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import LightGalleryIcon from "../../atoms/icons/lightGalleryIcon";
import LightGalleryIcon32x32 from "../../atoms/icons/LightGalleryIcon32x32";
import DefaultImage from "../../atoms/CardImage/default.svg";
import DfpAd from "../../dfp-ad";

import "./photo.m.css";

const PhotoStoryTemplate = ({ story, relatedStories, imageElements, publisherAttributes, jwtToken, storyIndex }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="ad-slot" className="top-ad">
        <DfpAd
          adtype={publisherAttributes === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}
          targetStory={story}
          slotId={`${publisherAttributes.lang === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}-${story.id.slice(
            -5
          )}-top-ad`}
        />
      </div>
      {story["hero-image-s3-key"] && (
        <div styleName="hero-image-wrappper">
          <div styleName="hero-image">
            <CardImage
              aspectRatio={isMobile ? [3, 2] : [1248, 500]}
              story={story}
              widths={isMobile ? [876] : [1248]}
              showStoryTypeIcon={false}
              imageType=""
            />
            {isMobile && <LightGalleryIcon32x32 />}
          </div>
          <div styleName="headline-wrapper">
            {!isMobile && <LightGalleryIcon />}
            <div className="headline-text-wrapper">
              <Headline
                text={story.headline}
                headerLevel={1}
                headlineType={40}
                className={`story-headline ${publisherAttributes.lang}-story-headline`}
              />
            </div>
          </div>
        </div>
      )}
      <StoryContent
        story={story}
        slicedStoryCards={story.cards}
        relatedStories={relatedStories}
        imageElements={imageElements}
        isPhotoStory={true}
        jwtToken={jwtToken}
        datatrackingcategory="Photo Sub Section"
        datatrackingaction="Click"
      />
      <img className="sun-logo" src={`${assetify(DefaultImage)}`} alt={story["hero-image-caption"] || story.headline} />
    </div>
  );
};

const PhotoStory = ({ story, relatedStories, imageElements, publisherAttributes, jwtToken, storyIndex }) => (
  <div className="story-grid">
    <PhotoStoryTemplate
      story={story}
      relatedStories={relatedStories}
      imageElements={imageElements}
      publisherAttributes={publisherAttributes}
      jwtToken={jwtToken}
      storyIndex={storyIndex}
    />
  </div>
);

PhotoStoryTemplate.propTypes = {
  story: object,
  relatedStories: array,
  imageElements: array,
  publisherAttributes: object,
  jwtToken: string,
  storyIndex: string,
};

PhotoStory.propTypes = {
  story: object,
  relatedStories: array,
  imageElements: array,
  publisherAttributes: object,
  jwtToken: string,
  storyIndex: number,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  storyIndex: get(state, ["headerReducer", "showStoryHeader", "storyIndex"], "0"),
});

export default connect(mapStateToProps, null)(PhotoStory);
